import { colors } from 'src/styles/colors';
import { getInitialLoadIcons } from 'src/styles/font';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';
import { DEVICE_WIDTH_CONSTANTS } from 'src/utils/constants/utilConstants';

import { useAppStore } from 'src/hooks/useAppStore';
import AccordionList from '../accordion';
import Button from '../buttons/Button';
import Modal from '../modal/Modal';
import {
  learnMoreAboutPlex1,
  learnMoreAboutPlex2
} from './PlexLearnNowPopupHelper';
import {
  buttonStyle,
  buttonText,
  firstAnswer,
  firstQuestion,
  plexLearnNowContainer,
  plexLearnNowFAQ,
  plexLearnNowHeader,
  rowContainer
} from './PlexLearnNowPopupStyle';

type PlexLearnNowPopupPropType = {
  show: boolean;
  closeHandler: (isOkBtn: boolean) => void;
};

const PlexLearnNowPopup = ({
  show,
  closeHandler
}: PlexLearnNowPopupPropType) => {
  const { appConfig, translations } = useAppStore();
  const translationData = translations?.plex;
  const learnNowFirstData = learnMoreAboutPlex1(translationData);
  const learnNowData = learnMoreAboutPlex2(translationData);
  const isTabletDevice =
    (appConfig.deviceWidth as number) >= DEVICE_WIDTH_CONSTANTS.deviceWidth900;

  return (
    <Modal
      show={show}
      onClose={() => closeHandler(false)}
      width="540px"
      height={isTabletDevice ? '497px' : '100%'}
      background={colors.white}
      renderCloseIcon={true}
      closeIconColor={colors.black}
      padding="30px"
      maxHeight={isTabletDevice ? 'none' : '65vh'}>
      <div
        css={plexLearnNowContainer}
        data-testid="plex-learn-now-popup-container">
        <div css={plexLearnNowHeader}>
          <div css={rowContainer}>
            <div css={firstQuestion}>{learnNowFirstData[0].title}</div>
            <div data-testid="plex-logo">
              <img
                src={`https://stcf-prod.zee5.com/prod/zee5Videojs/resources/images/zee-plex-logo.png`}
                title="plex Logo"
                alt="plex Logo"
                width="69px"
                height="35px"
              />
            </div>
          </div>
          <div css={firstAnswer}>{learnNowFirstData[0].descriptionItems}</div>
          <div css={plexLearnNowFAQ}>
            {translationData?.PlanSelection_FAQ_Text}
          </div>
        </div>

        <div>
          <AccordionList
            accordionContents={learnNowData}
            showLessIcon={getInitialLoadIcons(InitialLoadIconsSet.MINUS)}
            showMoreIcon={getInitialLoadIcons(InitialLoadIconsSet.PLUS)}
          />
        </div>
        <Button callback={() => closeHandler(true)} customStyles={buttonStyle}>
          <div css={buttonText} data-testid="consent-btn">
            {translationData?.How_Consent_Consent_Button}
          </div>
        </Button>
      </div>
    </Modal>
  );
};

export default PlexLearnNowPopup;
